import React from "react";
import { makeStyles } from "@material-ui/core";
import Appbar from "../../components/Appbar";
import Footer from "../../components/Footer";
import Planos from "../../components/Planos";
import Header from "../../components/Header";
import ParceirosF from "../../components/ParceirosF";
import Contato from "../../components/Contato";

export default function PlanosContato() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Header />
      <Appbar />
      <div className={classes.content}>
        <section id="planos">
          <Planos />
        </section>
        <div className={classes.contato}>
          <section id="contato">
            <Contato />
          </section>
        </div>
      </div>
      <ParceirosF />
      <Footer />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    width: "100vw",
    flexDirection: "column",
    display: "flex",
  },
  content: {
    flex: 1,
    marginTop: "16px",
    flexDirection: "column",
    alignItems: "center",
    paddingRight: "5px",
    paddingLeft: "5px",
    display: "flex",
  },
  contato: {
    width: "100%",
    maxWidth: "1386px",
    paddingRight: "10px",
    paddingLeft: "10px",
    marginTop: "48px",
    marginBottom: "48px",
  },
}));
